import React from 'react'

const SettingHandleEmail = ({ className }) => (
  <svg
    width="24px"
    height="48px"
    viewBox="0 0 24 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs />
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className={className} transform="translate(-63.000000, -37.000000)" fill="#FFFFFF">
        <path d="M63.508399,52.6678154 L76.9245555,37.6479458 C77.6603858,36.8241573 78.9247067,36.7528531 79.7484952,37.4886834 C80.0217833,37.7327918 80.2227544,38.0472897 80.3294682,38.3978428 L86.903753,59.9942636 C87.1068648,60.6614826 86.9477242,61.386322 86.4837868,61.9070884 L66.4933455,84.3462155 C65.7585952,85.1709675 64.4943688,85.2439282 63.6696169,84.5091779 C63.2436378,84.1296841 63,83.5863355 63,83.0158324 L63,54.0001541 C63,53.508659 63.18098,53.0343727 63.508399,52.6678154 Z" id="Rectangle-4" transform="translate(75.000000, 61.000000) scale(-1, 1) translate(-75.000000, -61.000000) " />
      </g>
    </g>
  </svg>

)

export default SettingHandleEmail



// WEBPACK FOOTER //
// ./src/components/assets/SettingHandleEmail.js